import { lazy, Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const bingoRegister = lazy(() => import('../pages/bingo-register'))

export const bingoRegisterRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/bingo-register',
  component: bingoRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
